import { render } from "./edit-target.vue?vue&type=template&id=591cb391"
import script from "./edit-target.vue?vue&type=script&lang=js"
export * from "./edit-target.vue?vue&type=script&lang=js"
script.render = render

export default script